import { render } from "./Dalenys.vue?vue&type=template&id=4bf48dc7"
import script from "./Dalenys.vue?vue&type=script&lang=js"
export * from "./Dalenys.vue?vue&type=script&lang=js"

import "./Dalenys.vue?vue&type=style&index=0&id=4bf48dc7&lang=css"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__